<template>
  <div>
    <small class="ruego">Rogamos respetar los destinatarios de cada capacitación, recomendamos leer la descripción para más información.</small>

    <div class="destinatarios">



      <div class="tags">
        <div class="tag-container" v-if="cargos">
          <h4>Cargos </h4>
          <span v-if="cargos && cargos.length">
            <span v-for="cargo in cargos" :key="cargo" class="tag cargo">{{ cargo }}</span>
          </span>
        </div>
        <div  class="tag-container" v-if="modalidades">
          <h4>Modalidades</h4>
          <span v-if="modalidades && modalidades.length">
            <span v-for="modalidad in modalidades" :key="modalidad" class="tag modalidad">{{ modalidad
              }}</span>
          </span>
        </div>
        <div class="tag-container" v-if="niveles">
          <h4>Niveles </h4>
          <span v-if="niveles && niveles.length">
            <span v-for="nivel in niveles" :key="nivel" class="tag nivel">{{ nivel }}</span>

          </span>
        </div>
        <div class="tag-container" v-if="areas">
          <h4>Áreas</h4>
          <span v-if="areas && areas.length">
            <span v-for="area in areas" :key="area" class="tag area">{{ area }}</span>
          </span>
        </div>
        <div class="tag-container" v-if="circuitos">
          <h4>Circuitos</h4>
          <span v-if="circuitos && circuitos.length">
            <span v-for="circuito in circuitos" :key="circuito" class="tag circuito">{{ circuito
              }}</span>
          </span>
        </div>
        <div class="tag-container" v-if="departamentos">
          <h4>Departamentos</h4>
          <span v-if="departamentos && departamentos.length">
            <span v-for="departamento in departamentos " :key="departamento" class="tag departamento">{{
              departamento
              }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['extras'],
data() {
  return {
    isConfirmed: false,
    cargos:[],
    modalidades:[],
    niveles:[],
    areas:[],
    circuitos:[],
    departamentos:[]

  }
},
mounted()
{
  this.cargos = this.extras.cargos && this.extras.cargos.split(',') ? this.extras.cargos.split(',') : 0
  this.modalidades = this.extras.modalidades && this.extras.modalidades.split(',') ? this.extras.modalidades.split(',') : 0
  this.niveles = this.extras.niveles && this.extras.niveles !== 'Todos' ? this.extras.niveles.split(',') : 0
  this.areas =  this.extras.areas ? this.extras.areas.split(',') : 0
  this.circuitos = this.extras.circuitos && this.extras.circuitos !== 'Todos' ? this.extras.circuitos.split(',') : 0
  this.departamentos = this.extras.departamentos && this.extras.departamentos !== 'Todos' ? this.extras.departamentos.split(',') : 0
},
created()
{
  // console.log(this.extras);
}
};
</script>

<style scoped>
.destinatarios {
  /* border: 2px solid #ccc; */
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  /* margin: 20px 0; */
}

.ruego {
 line-height: 1.2;
 display: block;
 padding:10px 20px;
 font-size: 13px;
  background-color: #FFEBEE;
  font-weight: 600;
}

.tags {
  display: flex;
  flex-wrap: wrap;
}

.tag-container {
  margin-right: 20px;
}

.tag-container h4 {
  font-size: 16px;
  margin-bottom: 10px;
}

.tag {
  display: inline-block;
  padding: 4px 8px;
  margin: 5px ;
  border-radius: 3px;
  color: white;
  font-size: 12px;
}

.cargo {
  background-color: #007bff;
}

.modalidad {
  background-color: #28a745;
}

.nivel {
  background-color: #17a2b8;
}

.area {
  background-color: #ffc107;
}

.circuito {
  background-color: #dc3545;
}

.departamento {
  background-color: #6c757d;
}


</style>
